import React, {useEffect, useState} from "react";
import { useDispatch } from 'react-redux';
import CameraIcon from "../../elements/icons/CameraIcon";
import { baseUrl, calculateAge, userDetails, authHeader } from "../../../utils";
import ModalDialog from "../../layouts/ModalDialog";
import FileUpload from "../../elements/form/FileUpload";
import ModalActionButton from "../../elements/ModalActionButton";
import axios from "axios";
import { ERROR, SET_SUCCESS } from "../../../store/types";
import Loader from "../../elements/Loader";
import UpdateUserRoles from "./UpdateUserRoles";
const StaffOverviewCard = ({ staff, reload }) => {
  const access =
    staff?.userProfile
      ? "Available"
      : staff?.invitation?.userProfileRequired && !staff.userProfile
        ? "Pending"
        : "No access";
  const accessTone =
    access === "Available"
      ? "bg-emerald-50 text-emerald-700"
      : access === "Pending"
        ? "bg-amber-50 text-amber-700"
        : "bg-gray-100 text-gray-600";
  const name =
    staff?.fullName ||
    `${staff?.firstName || ""}${staff?.otherNames ? ` ${staff.otherNames.charAt(0)}.` : ""} ${staff?.lastName || ""}`;

  const currentStaffLoggedIn = staff?._id === userDetails()?.staffMemberProfile;
  const [changingPhoto, setChangingPhoto] = React.useState(false);

  const [file, setFile] = React.useState(null);
  const [validationErrors, setValidationErrors] = React.useState({});

  const dispatch = useDispatch();

  const validateForm = () => {
    let errors = {}

    if(!file || file === '') {
        errors.file = true
    }

    setValidationErrors(errors)

    return errors
  }

  const [loading, setLoading] = useState(true)
  const [userProfile, setUserProfile] = useState(null)
  const [reloadProfile, setReloadProfile] = useState(0)
  useEffect(() => {
    const fetchEmployeeUserProfile = async () => {
        setLoading(true)
        try {
          const headers = { 'Content-Type': 'application/json', ...authHeader() }
          const response = await axios.get(`${baseUrl}/user/profile/${staff?.userProfile?._id || staff?.userProfile}?expand=adminRoles`, { headers })
          setUserProfile(response.data.data)
        } catch (error) {
          console.error('Error fetching staff user profile: ', error)
          dispatch({
            type: ERROR,
            error
          })
        } finally {
          setLoading(false)
        }
    }

    if(staff?.userProfile){
      fetchEmployeeUserProfile()
    } else {
      setLoading(false)
    }


    return () => {
        
    };
  }, [dispatch, staff?.userProfile?._id, staff?.userProfile, reloadProfile]);

  const [processing, setProcessing] = React.useState(false)

  const handleUpload = async (file) => {

      var formData = new FormData()
      formData.append('file', file.file )
      const headers = new Headers();
      headers.append("Authorization",  authHeader().Authorization);

      try {
        setProcessing(true)
        const doUpload = await fetch(`${process.env.REACT_APP_BASE_URL}/files/new`, {
            method: "POST",
            headers,
            body: formData,
        });
        const response = await doUpload.json();

        return response
      } catch (error) {
        dispatch({
          type: ERROR,
          error,
        });
      }
  }

  const pushUpdate = async () => {
    if (Object.values(validateForm()).includes(true)) {
      return
    }
    const headers = { 'Content-Type': 'application/json', ...authHeader() }
    const uploaded = await handleUpload(file) 
    const payload = {
      photo: uploaded.data.file
    }

    try {
      setProcessing(true) 
      await axios.patch(`${baseUrl}/user/profile/staff`, payload, { headers })
      setProcessing(false)
      dispatch({
          type: SET_SUCCESS,
          payload: "Personal information updated successfully"
      })
      reload()
      setChangingPhoto(false)
    } catch (error) {
      console.error(error)
      dispatch({
          type: ERROR,
          error
      })
      setProcessing(false)    
    }
  }

  const [updatingRoles, setUpdatingRoles] = React.useState(false)

  return (
    <>
      {
        loading ? 
          <Loader />
        :
          <aside className="w-full overflow-hidden ">
            <div
              className="flex h-[220px] items-center justify-center bg-gray-50"
              style={{
                backgroundImage: `url("${staff?.avatar || staff?.photo || ""}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              {!staff?.avatar && !staff?.photo && (
                <CameraIcon className="h-8 w-8 text-gray-300" />
              )}
            </div>

            {currentStaffLoggedIn && <div className="p-3 border border-dashed rounded-lg mt-4 bg-gray-50 border-gray-300">
              <button onClick={()=>{setChangingPhoto(true)}} className="text-xs font-semibold font-space-grotesk text-gray-600 rounded-lg bg-gray-200 hover:bg-gray-300 transition duration-200 px-4 py-3">Change/Set Photo</button>
            </div>}
            
            <div className="py-5">
              <p className="font-space-grotesk text-base font-semibold text-gray-900">
                {name}
              </p>
              <p className="mt-1 text-xs font-medium uppercase tracking-wider text-vcm-dark-gray">
                {staff?.staffId || "No staff ID"}
              </p>
              <div className="mt-5 rounded-lg bg-vcm-light-purple/20 p-3">
                <p className="text-xs text-vcm-dark-gray">Current role(s)</p>
                <p className="mt-1 text-sm font-medium text-gray-900">
                  {staff?.designations?.map(d => d.name).join(', ') || "Not assigned"}
                </p>
                <p className="mt-1 text-xs text-vcm-dark-gray">
                  {staff?.department?.name || "No department assigned"}
                </p>
              </div>
              <div className="mt-3 grid grid-cols-2 gap-3">
                <div className="rounded-lg border border-gray-100 p-3">
                  <p className="text-xs text-vcm-dark-gray">Staff type</p>
                  <p className="mt-1 text-sm font-medium capitalize text-gray-900">
                    {staff?.staffType?.toLowerCase().replace("_", " ") ||
                      <span className='text-gray-400'>Not provided</span>}
                  </p>
                </div>
                <div className="rounded-lg border border-gray-100 p-3">
                  <p className="text-xs text-vcm-dark-gray">Age</p>
                  <p className="mt-1 font-space-grotesk text-sm font-medium text-gray-900">
                    {staff?.dob ? calculateAge(staff.dob) : <span className='text-gray-400'>Not provided</span>}
                  </p>
                </div>
              </div>
              <div className="mt-4 border-t border-gray-100 pt-4">
                <p className="text-xs text-vcm-dark-gray">System access</p>
                <span
                  className={`mt-2 font-outfit inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${accessTone}`}
                >
                  {access}
                </span>
              </div>

              {userProfile && userProfile?.adminRoles?.length > 0 && <div className="mt-4 border-t border-gray-100 pt-4">
                <div className="flex items-start justify-between">
                  <p className="text-xs text-vcm-dark-gray">System Roles</p>
                  {!currentStaffLoggedIn && <button onClick={() => setUpdatingRoles(true)} className='text-xs inline text-gray-700 transition duration-200 hover:text-gray-400 underline'>Update Roles</button>}
                </div>
                <p
                  className={`mt-2 font-outfit inline-flex rounded-full capitalize text-xs font-medium`}
                >
                  {userProfile?.adminRoles?.map(role => role.name).join(', ')}
                </p>
              </div>}

              {staff?.offboarding?.offboarded && (
                <div className="mt-4 rounded-lg bg-rose-50 p-3 text-xs font-medium text-rose-700">
                  This staff member has been offboarded.
                </div>
              )}
            </div>
          </aside>
      }

      <ModalDialog
        shown={changingPhoto} 
        closeFunction={()=>{setChangingPhoto(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Change your profile photo'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <div className='mt-2 w-full'>
          <FileUpload
            hasError={validationErrors.file}
            fieldLabel={`Profile photo`}
            returnFileDetails={(details)=>{
                setFile(details)
            }}
            acceptedFormats={['png', 'jpeg', 'jpg']}
          />
          <label className='block mt-3 text-xs text-gray-400'>{`A passport photo for your profile`}</label>
        </div>

        <div className="mt-8 flex flex-row-reverse gap-x-4">
          <ModalActionButton
            buttonLabel={`Update Photo`}
            buttonAction={()=>{pushUpdate()}}
            processing={processing}
          />

          <button
            type="button"
            className="inline-flex font-space-grotesk justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary/40 focus:outline-none"
            onClick={()=>{setChangingPhoto(false)}}
          >
            Close
          </button>
            
        </div>
      </ModalDialog>

      <ModalDialog
        shown={updatingRoles} 
        closeFunction={()=>{setUpdatingRoles(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Update System Roles for ${staff?.firstName || 'this staff'}`}
        maxWidthClass='max-w-md'
        hideActions={true}
      >
          <UpdateUserRoles 
              staff={staff} 
              currentRoles={userProfile?.adminRoles || []}
              close={()=>setUpdatingRoles(false)} 
              reload={()=>setReloadProfile(prev => prev + 1)}
          />
      </ModalDialog>
    </>
  );
};

export default StaffOverviewCard;
